import { Set, getIn } from 'immutable'


/** @return {?number} (null if no active preset profile) */
export const selectActivePresetProfileId = state => {
  const activeId = getIn(state.user, ['activePresetProfile'])
  return getIn(state.user, ['profiles', activeId, 'id'], null)
}

/** @return {string} */
export const selectActivePresetProfileName = state => {
  const activeId = getIn(state.user, ['activePresetProfile'])
  return getIn(state.user, ['profiles', activeId, 'name'], 'Näytä kaikki')
}

/** @return {Immutable.Set<number>} (empty set if no active preset profile) */
export const selectPresetBlacklistedCategoryIds = state => {
  const activeId = getIn(state.user, ['activePresetProfile'])
  return getIn(state.user, ['profiles', activeId, 'categoryBlacklist']) ?? Set()
}
